
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import moment from "moment";
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { AssetTypeDataDDL } from '../../../../../Components/CommonDDL/AssetTypeDataDDL';
import { Loading } from '../../../../../Helper/Loading';
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch, useSelector } from 'react-redux';
import { HorticultureWorkAssignedTableDataAPI } from '../../../../../Redux/CommDashbaord/WorkAssignByOfficialsSlice/HorticultureSlice';
import { Pegination } from '../../../../../Components/Pegination/Pegination';
import ViewURL from '../../../../../Components/ViewURL/ViewURL';
import { useTranslation } from 'react-i18next';
import CommonDashboardScreenWardDDL from '../../../../../Components/CommonDDL/CommonDashboardScreenWardDDL';
import { WardWiseAssetNameDataDDL } from '../../../../../Components/CommonDDL/WardWiseAssetDDL';
import { WorkTypeDDL } from '../../../../../Components/CommonDDL/WorkTypeDDL';
import { ContractorWiseAssetDDL } from '../../../../../Components/CommonDDL/WorkTypeWiseContractorDDL';
import AfterWorkPhotoModal from '../../../../../Components/ViewURL/AfterWorkPhotoModal';

export default function CivilWorkAssignedByOfficialTable() {

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ZWard = searchParams.get("ZoneName")
    let ZLable = searchParams.get("ZLable")
    let ZoneValue = searchParams.get("ZoneName")
    let FlagName = searchParams.get("Flag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let RoleID = searchParams.get("RoleID")
    let WorkPeriodID = searchParams.get("WorkPeriodID")
    let Lang = searchParams.get("Lang")

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: HYear && HYear ? HYear : '0',
        Label: YLable && YLable ? YLable : "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: HMonth && HMonth ? HMonth : '0',
        Label: MLable && MLable ? MLable : "Select...",
    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [ZoneNameDDLID, setZoneNameDDLID] = useState({
        DDL: [],
        ID: ZWard && ZWard ? ZWard : '0',
        Label: ZLable && ZLable ? ZLable : "Select...",
        // ID: 0,
        // Label: "Select...",

    })
    const [WorkAssignedBy, setWorkAssignedBy] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [AssetType, setAssetType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [AssetName, setAssetName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ContractorName, setContractorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WardWiseAssetName, setWardWiseAssetName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ContractorWiseAsset, setContractorWiseAsset] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [showWorkImagePopup, setshowWorkImagePopup] = React.useState(false)
    const [AfterWorkPhotoData, setAfterWorkPhotoData] = React.useState('')
    const [workPhotoData, setworkPhotoData] = React.useState('')
    const [Heading, setHeading] = React.useState(false)
    const [FromDate, setFromDate] = useState('')
    // moment().startOf('month').format('YYYY-MM-DD')
    const [ToDate, setToDate] = useState('')
    // moment().format('YYYY-MM-DD')

    const YearMonth = () => {

        if (((moment().startOf('month').format('M')) == HMonth) && (moment().format('YYYY') == HYear)) {
            // console.log("ifdfgdfg")
            setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
            setToDate(moment().format('YYYY-MM-DD'))
        } else {
            // console.log("else" )
            setFromDate(moment(HMonth, 'M').year(HYear, 'YYYY').startOf('month').format('YYYY-MM-DD'))
            setToDate(moment(HMonth, 'M').year(HYear, 'YYYY').endOf('month').format('YYYY-MM-DD'))

        }
    }

    useEffect(() => {
        if (FromDate != moment().startOf('month').format('YYYY-MM-DD')) {
            setToDate(moment(HMonth, 'MM').year(HYear, 'YYYY').endOf('month').format('YYYY-MM-DD'))
        }
    }, [FromDate])

    useEffect(() => {
        YearMonth()
    }, [])

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setFromDate('')
        YearMonth()
        setToDate('')
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setZoneNameDDLID({
            ...ZoneNameDDLID,
            ID: ZWard && ZWard ? ZWard : '0',
            Label: ZLable && ZLable ? ZLable : "Select...",
        })
        setAssetType({
            ...AssetType,
            ID: AssetType.DDL[0].value,
            Label: AssetType.DDL[0].label,
        })
        setWorkAssignedBy({
            ...WorkAssignedBy,
            ID: 0,
            Label: 'Select...',
        })
        setWorkType({
            ...WorkType,
            ID: WorkType.DDL[1].value,
            Label: WorkType.DDL[1].label,
        })
        setWardWiseAssetName({
            ...WardWiseAssetName,
            ID: 0,
            Label: 'Select...'
        })
        setContractorWiseAsset({
            ...ContractorWiseAsset,
            ID: 0,
            Label: 'Select...'
        })
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }

    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    const handleWorkShowImage = (Imageurl, heading) => {
        setshowWorkImagePopup(true)
        setworkPhotoData(Imageurl?.workPhoto)
        setAfterWorkPhotoData(Imageurl?.afterWorkPhoto)
        setHeading(heading)
    }

    const handleFromToDate = (fromdate) => {
        setFromDate(fromdate)
        setToDate('')
    }


    useEffect(() => {
        const data = {
            FromDate: FromDate != 'Invalid date' ? FromDate : '',
            ToDate: ToDate != 'Invalid date' ? ToDate : '',
            M_WardID: WardName.ID,
            WorkAssignByM_UserID: 4,
            M_AssetTypeID: AssetType.ID,
            M_AssetID: WardWiseAssetName.ID,
            M_GD_WorkPeriodID: WorkPeriodID,
            M_WorkTypeID: WorkType.ID,
            M_UsersID: UserID,
            ShowBy: 'CivilWork',
            M_ContractorID: ContractorWiseAsset.ID,
            token: token,
            From: From,
            To: To,
            // Flag: 'ExecutiveEngineer',
            M_RoleID: RoleID,
            M_ZoneID: ZoneNameDDLID.ID,
            Language: Language.Label,
        }
        { Language.Label != '' && ZoneNameDDLID.ID != '0' && AssetType.ID != '0' && WorkType.ID != '0' && dispatch(HorticultureWorkAssignedTableDataAPI({ data })) }
    }, [Language.Label, FromDate, ToDate, ZoneNameDDLID.ID, IsPost, To, WardName.ID, AssetType.ID, WardWiseAssetName.ID, ContractorWiseAsset.ID, WorkType.ID, IsClear])
    const { tableData, isLoading } = useSelector(state => state.HorticultureWorkAssignedTableData)

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameDDLID.ID, WardName.ID, AssetType.ID, WardWiseAssetName.ID, WorkType.ID, ContractorWiseAsset.ID])

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Garden Maintainance"
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName}
                    Language={Language}
                    setLanguage={setLanguage}
                />
                <div className="wrapper">
                    <Sidebar Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div id="" className='content1'>
                        <div className='data_mob'>
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='col-8'>
                                    <h5 className="ps-1 pt-1">{t('Dashboard.Titles.Civil_Work_Assigned_By_Officials')} :- {searchName}</h5>
                                </div>
                                <div className='col-4'>
                                    {/* <button type="button" className="btn btn-primary float-end mr-1">Export</button> */}
                                </div>

                                <div className="row m-0 mt-1">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12 ">
                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-6 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>{t('Dashboard.Work_Assigned_by_Officials.From_Date')} :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            max={moment().format('YYYY-MM-DD')}
                                                            // onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                            onChange={(e) => handleFromToDate(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-2">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>{t('Dashboard.Work_Assigned_by_Officials.To_Date')} :</b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            min={FromDate}
                                                            max={moment().format('YYYY-MM-DD')}
                                                            onChange={(e) => setToDate(e.target.value)}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-5">
                                                    <CommonDashboardScreenWardDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        WLable={WLable}
                                                        HWard={HWard}
                                                        ZLable={ZLable}
                                                        ZWard={ZWard}
                                                        Language={Language}
                                                        ZoneNameDDLID={ZoneNameDDLID}
                                                        setZoneNameDDLID={setZoneNameDDLID}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <AssetTypeDataDDL
                                                        AssetType={AssetType}
                                                        setAssetType={setAssetType}
                                                        Language={Language}
                                                        Flag='SportScreenOnly'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-3">

                                                    <WardWiseAssetNameDataDDL
                                                        WardWiseAssetName={WardWiseAssetName}
                                                        setWardWiseAssetName={setWardWiseAssetName}
                                                        WardName={WardName}
                                                        AssetType={AssetType}
                                                        M_WorkTypeID={WorkType.ID}
                                                        M_ZoneID={ZoneNameDDLID}
                                                        M_RoleID={RoleID}
                                                        M_GD_WorkPeriodID={WorkPeriodID}
                                                        // M_AssetTypeID={1}
                                                        Language={Language}
                                                        Flag='CivilWork'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-5 col-lg-3">
                                                    <WorkTypeDDL
                                                        WorkType={WorkType}
                                                        setWorkType={setWorkType}
                                                        IsPost={IsPost}
                                                        Language={Language}
                                                        Flag1='Civil'
                                                    />
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <ContractorWiseAssetDDL
                                                        ContractorWiseAsset={ContractorWiseAsset}
                                                        setContractorWiseAsset={setContractorWiseAsset}
                                                        WorkType={WorkType}
                                                        WardWiseAssetName={WardWiseAssetName}
                                                        RoleID={RoleID}
                                                        Flag='CivilWork'
                                                        Language={Language}
                                                        // rowData={rowData}
                                                        // Flag={Flag}
                                                        // M_WorkTypeID={WorkType.ID}
                                                        Flag1='ContractorName'
                                                        ZoneNameDDLID={ZoneNameDDLID}
                                                        AssetType={AssetType}
                                                        WorkPeriodID={WorkPeriodID}
                                                    />
                                                </div>
                                                <div className="col-12 col-lg-3 col-md-4 mt-lg-4 d-md-flex" >
                                                    {/* <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button> */}
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="">{t('Dashboard.Pcmc_Assets.Sr_No')}</th>
                                                            <th style={{ width: "7em" }}>{t('Dashboard.Work_Assigned_by_Officials.Assign_Date')}</th>
                                                            {/* <th>Work Type</th> */}
                                                            <th style={{ width: "17em" }}>{t('Dashboard.Pcmc_Assets.Asset_Name')}</th>
                                                            {/* <th>{t('Dashboard.Pcmc_Assets.Sector_Name')}</th> */}
                                                            <th style={{ width: "13em" }}>{t('Dashboard.Work_Assigned_by_Officials.Area1')}</th>
                                                            <th>{t('Dashboard.Work_Assigned_by_Officials.Work_Name')}</th>
                                                            <th style={{ width: "2em" }}>{t('Dashboard.Work_Assigned_by_Officials.Assign_Work_Photo')}</th>
                                                            <th style={{ width: "8em" }}>{t('Dashboard.Work_Assigned_by_Officials.Officer_Name')}</th>
                                                            <th>{t('Dashboard.Work_Assigned_by_Officials.Assign_Contractor_Name')}</th>
                                                            <th>{t('Dashboard.Work_Assigned_by_Officials.Work_Date')}</th>
                                                            <th style={{ width: "2em" }}>{t('Sidebar.After_Work_Photo')}</th>
                                                            <th>{t('Dashboard.Pcmc_Assets.Status')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center", verticalAlign: 'middle' }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>{item.workAssignDate ? moment(item.workAssignDate).format('DD-MM-YYYY') : '-'}</td>
                                                                    {/* <td></td> */}
                                                                    <td style={{ verticalAlign: 'middle' }}>{item.assetName ? item.assetName : '-'}</td>
                                                                    {/* <td>{item.sectorName ? item.sectorName : '-'}</td> */}
                                                                    <td style={{ verticalAlign: 'middle' }}>{item.areaName ? item.areaName : '-'}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>{item.workname ? item.workname : '-'}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: 'middle' }}>
                                                                        {
                                                                            (item.workPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleShowImage(item.workPhoto),
                                                                                            setHeading("Assign Work Photo")
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ verticalAlign: 'middle' }}>{item.assingBy ? item.assingBy : '0'}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>{item.contractorName ? item.contractorName : '-'}</td>
                                                                    <td style={{ whiteSpace: "nowrap", verticalAlign: 'middle' }}>{item.workDate ? moment(item.workDate).format('DD-MM-YYYY') : '-'}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: 'middle' }}>
                                                                        {
                                                                            (item.afterWorkPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => (
                                                                                            handleWorkShowImage(item),
                                                                                            setHeading("Completed Work Photo")
                                                                                        )}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ padding: '10px', verticalAlign: 'middle' }}>
                                                                        <span className={item.statusName === "Pending" || item.statusName === "प्रलंबित" ? "Pendingstatus" : "Completedstatus"}>{item.statusName ? item.statusName : '-'}</span>
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No Found data</ td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    IsClear={IsClear}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {
                    showWorkImagePopup ?
                        <AfterWorkPhotoModal
                            Heading={Heading}
                            setshowWorkImagePopup={setshowWorkImagePopup}
                            workPhotoData={workPhotoData}
                            AfterWorkPhotoData={AfterWorkPhotoData}
                        />
                        : ''
                }
                {
                    showImagePopup ?
                        <ViewURL
                            Heading={Heading}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}
                        />
                        : ''
                }
            </div>
        </>

    )
}